import { EnvCheckService } from '@/services/exam/envCheck.service';
import { CountdownService } from '@/services/countdown.service';
import { MediaService } from '@/services/exam/media.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { defineComponent } from 'vue';
import UserEnvCheckStage1 from './components/UserEnvCheckStage1.vue';
import UserEnvCheckStage2 from './components/UserEnvCheckStage2.vue';
import UserEnvCheckStage3 from './components/UserEnvCheckStage3.vue';
export default defineComponent({
  name: 'UserEnvCheck',
  components: {
    UserEnvCheckStage1: UserEnvCheckStage1,
    UserEnvCheckStage2: UserEnvCheckStage2,
    UserEnvCheckStage3: UserEnvCheckStage3
  },
  setup: function setup() {
    declareProviders([EnvCheckService, CountdownService, MediaService]);
    var envCheckService = useService(EnvCheckService);
    return {
      envCheckService: envCheckService
    };
  }
});